import { maskPhoneNumber } from '../../../../../masks/masks'

const getStatusLabel = (
  hasJoinedCommunity: boolean,
  isInviteLinkExpired: boolean
) => {
  if (hasJoinedCommunity) return 'Entrou no grupo'
  if (isInviteLinkExpired) return 'Link expirado'
  return 'Aguardando entrada'
}

const getStatusChipStyles = (
  hasJoinedCommunity: boolean,
  isInviteLinkExpired: boolean
) => {
  if (hasJoinedCommunity) {
    return {
      backgroundColor: 'rgba(28, 189, 63, 0.16)', // verde claro
      color: 'rgba(0, 157, 35, 1)', // verde escuro (sucesso)
    }
  }
  if (isInviteLinkExpired) {
    return {
      backgroundColor: 'rgba(189, 28, 28, 0.16)', // vermelho claro
      color: 'rgba(212, 54, 44, 1)', // vermelho (atenção)
    }
  }
  return {
    backgroundColor: 'rgba(112, 114, 117, 0.12)', // cinza claro
    color: 'rgba(112, 114, 117, 1)', // cinza neutro (aguardando)
  }
}

const formatPhone = (phone: string | null) => {
  if (!phone) return '-'
  const digitsOnly = phone.replace(/\D/g, '')
  const withoutCountryCode =
    digitsOnly.length > 11 && digitsOnly.startsWith('55')
      ? digitsOnly.slice(2)
      : digitsOnly
  return maskPhoneNumber(withoutCountryCode)
}

const CommunityMemberFunctions = {
  getStatusLabel,
  getStatusChipStyles,
  formatPhone,
}

export default CommunityMemberFunctions
